import React from 'react';
import Statistics from '../components/statistics';

import Data from '../pages/article/IneraEmbedded.json';

const PowerBIBlock = (props) => {
  return <Statistics data={Data} {...props} />;
};

export default PowerBIBlock;
